import { createSlice } from "@reduxjs/toolkit";
import {
  addProductsAndServices,
  fetchProductsAndServices,
  fetchProductsAndServicesById,
  updateProductsAndServices,
  fetchProductsAndServicesByType,
  updateStatusInProductsAndServices,
  fetchProductsAndServicesByDropDown,
  fetchCategories,
  fetchSubcategories,
  fetchMakes,
  fetchModels,
  fetchProductsDropDownBasedOnModel,
  fetchProductsAndServicesBasedOnModel,
  fetchModel
} from "./thunk";

interface ProductsAndServicesState {
  productsandservicesList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedProductsAndServices: any;
  categories: any[];
  subcategories: any[];
  makes: any[];
  models: any[];
  fetchProductsDropDownBasedOnModel:any[];
  fetchProductsAndServicesBasedOnModel:any[];
  fetchModel:any[];
}

const initialState: ProductsAndServicesState = {
  productsandservicesList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedProductsAndServices: null,
  categories: [],
  subcategories: [],
  makes: [],
  models: [],
  fetchProductsDropDownBasedOnModel:[],
  fetchProductsAndServicesBasedOnModel:[],
  fetchModel:[]
};

const productsAndServicesSlice = createSlice({
  name: "productsandservices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
     .addCase(fetchProductsAndServicesByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsAndServicesByDropDown.fulfilled, (state, action) => {
        console.log(action.payload, "line no 38 in action reduer")
        state.loading = false;
        state.productsandservicesList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProductsAndServicesByDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Products and Services";
      })
        .addCase(fetchProductsAndServicesByType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsAndServicesByType.fulfilled, (state, action) => {
        console.log(action.payload, "line no 38 in action reduer")
        state.loading = false;
        state.productsandservicesList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProductsAndServicesByType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Products and Services";
      })
      .addCase(fetchProductsAndServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsAndServices.fulfilled, (state, action) => {
        state.loading = false;
        state.productsandservicesList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProductsAndServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Products and Services";
      })
      .addCase(fetchProductsAndServicesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsAndServicesById.fulfilled, (state, action) => {
        console.log(action.payload, "line 65 in reducerproductand")
        state.loading = false;
        state.selectedProductsAndServices = action.payload;
      })
      .addCase(fetchProductsAndServicesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProductsAndServices.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.productsandservicesList = state.productsandservicesList.map((productsAndServices) =>
          productsAndServices.id === action.payload.id ? action.payload : productsAndServices
        );
      })
      .addCase(addProductsAndServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProductsAndServices.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.productsandservicesList = state.productsandservicesList.map((productsAndServices) =>
          productsAndServices.id === action.payload.id ? action.payload : productsAndServices
        );
      })
      .addCase(updateProductsAndServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProductsAndServices.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.productsandservicesList = state.productsAndServicesList.map((productsAndServices) =>
        //   productsAndServices.id === action.payload.id ? action.payload : productsAndServices
        // );
      })
      .addCase(updateStatusInProductsAndServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
      // Categories
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        // Handle both direct array response and wrapped response
        state.categories = Array.isArray(action.payload) 
          ? action.payload 
          : (action.payload?.data || action.payload || []);
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Subcategories
      .addCase(fetchSubcategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubcategories.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        if (Array.isArray(payload)) {
          // Check if this is a services response (has item_type: "services" or item_name, service_code)
          const isServicesResponse = payload.length > 0 && (
            payload[0].item_type === "services" || 
            payload[0].service_code !== undefined ||
            payload[0].item_name !== undefined
          );
          
          if (isServicesResponse) {
            // For services: Store the full service objects so we have all service details
            // Each service object contains: id, item_name, service_code, selling_price, gst_percent, etc.
            state.subcategories = payload;
          } else {
            // For products: Extract unique subcategories (existing behavior)
            const subcategoryMap = new Map();
            payload.forEach((item: any) => {
              if (item.subcategory_id && item.subcategory_name) {
                if (!subcategoryMap.has(item.subcategory_id)) {
                  subcategoryMap.set(item.subcategory_id, {
                    id: item.subcategory_id,
                    subcategory_id: item.subcategory_id,
                    name: item.subcategory_name,
                    subcategory_name: item.subcategory_name,
                  });
                }
              }
            });
            state.subcategories = Array.from(subcategoryMap.values());
          }
        } else {
          state.subcategories = payload;
        }
      })
      .addCase(fetchSubcategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Makes
      .addCase(fetchMakes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMakes.fulfilled, (state, action) => {
        state.loading = false;
        state.makes = action.payload;
      })
      .addCase(fetchMakes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Models
      .addCase(fetchModels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModels.fulfilled, (state, action) => {
        state.loading = false;
        state.models = action.payload;
      })
      .addCase(fetchModels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // only for model
      .addCase(fetchModel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModel.fulfilled, (state, action) => {
        state.loading = false;
        state.models = action.payload;
      })
      .addCase(fetchModel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
        // ✅ 👉 Add here
        .addCase(fetchProductsAndServicesBasedOnModel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchProductsAndServicesBasedOnModel.fulfilled, (state, action) => {
          state.loading = false;
          state.fetchProductsAndServicesBasedOnModel = action.payload || [];
        })
        .addCase(fetchProductsAndServicesBasedOnModel.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
        })
            .addCase(fetchProductsDropDownBasedOnModel.pending, (state) => {
              state.loading = true;
              state.error = null;
            })
            .addCase(fetchProductsDropDownBasedOnModel.fulfilled, (state, action) => {
              state.loading = false;
              state.fetchProductsDropDownBasedOnModel = action.payload || [];
            })
            .addCase(fetchProductsDropDownBasedOnModel.rejected, (state, action) => {
              state.loading = false;
              state.error = action.payload as string;
            })
  },
});

export default productsAndServicesSlice.reducer;
